export default function () {
  return function (input) {
    var re = /{(.*)}/;
    var output = input.match(re);
    return output[1];
  }
}